import type { FC, ReactNode } from 'react'

export interface SidePanelContentProps {
	/**
	 * Content to display in the panel
	 */
	children: ReactNode | ReactNode[] | undefined
}

export const SidePanelContent: FC<SidePanelContentProps> = ({ children }) => {
	return (
		<div data-testid="SidePanelContent" className="p-3">
			{children}
		</div>
	)
}
